import type { Ref } from 'react'
import { useEffect } from 'react'

/**
 * Proper state management for nested modals.
 * Simplified, but inspired by material-ui's ModalManager class.
 */
class DialogManager {
  dialogs: any[]

  constructor() {
    this.dialogs = []
  }

  add(dialog: any) {
    this.dialogs.push(dialog)
  }

  remove(dialog: any) {
    this.dialogs = this.dialogs.filter(_dialog => _dialog !== dialog)
  }

  isTopDialog(dialog: any) {
    const topmostDialog = this.dialogs[this.dialogs.length - 1]
    return topmostDialog === dialog
  }
}

export const dialogManager = new DialogManager()

export function useDialogManager(ref: Ref<any>, isOpen?: boolean) {
  useEffect(() => {
    if (isOpen) {
      dialogManager.add(ref)
    }
    return () => {
      dialogManager.remove(ref)
    }
  }, [isOpen, ref])
}
